import { render, staticRenderFns } from "./miningList.vue?vue&type=template&id=59de349a&scoped=true&"
import script from "./miningList.vue?vue&type=script&lang=js&"
export * from "./miningList.vue?vue&type=script&lang=js&"
import style0 from "./miningList.vue?vue&type=style&index=0&id=59de349a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59de349a",
  null
  
)

export default component.exports